const BEACON = 'https://api.squdle.com/e';
const K = { i: 'squdle-telemetry-init', d: 'squdle-device-id', s: 'squdle-session', o: 'squdle-telemetry-optout' };
const PROD = new Set(['www.squdle.com', 'squdle.com']);
const GAP = 1800000;

const g = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
const s = (k, v) => { try { localStorage.setItem(k, v); } catch { /* blocked */ } };
const host = () => {
  try {
    if (typeof globalThis.__squdleTelemetryHost === 'string') return globalThis.__squdleTelemetryHost;
    return location.hostname;
  } catch { return ''; }
};
const blocked = () => {
  try {
    return !PROD.has(host()) || g(K.o) === '1' || navigator.globalPrivacyControl === true;
  } catch { return true; }
};
const j = (k) => { const r = g(k); if (!r) return null; try { return JSON.parse(r); } catch { return null; } };
const prior = () => {
  try { for (let i = 0; i < localStorage.length; i++) if (localStorage.key(i)?.startsWith('squdle-')) return 1; } catch { /* blocked */ }
  return 0;
};
const sid = () => j(K.s)?.id ?? null;
const cohort = (sessionId) => {
  const init = j(K.i);
  if (!init) return { prior_state: null, fs: 0 };
  const fs = sessionId === init.first_session ? 1 : 0;
  return fs ? { prior_state: init.prior_state, fs, first_ref: init.first_ref ?? null } : { prior_state: init.prior_state, fs };
};
const writeS = (id, ts) => { s(K.s, JSON.stringify({ id, lastTs: ts })); return id; };
const send = (evt) => {
  if (blocked()) return;
  try {
    const body = JSON.stringify(evt);
    try {
      if (typeof navigator.sendBeacon === 'function' && navigator.sendBeacon(BEACON, body)) return;
    } catch { /* beacon threw — fall through */ }
    fetch(BEACON, { method: 'POST', body, keepalive: true, mode: 'no-cors' }).catch(() => {});
  } catch { /* ignore */ }
};
const open = (ref) => {
  const dev = g(K.d); if (!dev) return;
  const id = crypto.randomUUID();
  writeS(id, Date.now());
  send({ device_id: dev, session_id: id, name: 'app_open', ref: ref ?? null, ...cohort(id) });
};
const sync = () => {
  const sess = j(K.s);
  if (!sess || Date.now() - sess.lastTs > GAP) open(null);
};
const stripRef = () => {
  try { const u = new URL(location.href); u.searchParams.delete('ref'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch { /* ignore */ }
};
const ensureInit = (urlShare) => {
  if (j(K.i)) return false;
  if (g(K.d)) return false;
  const firstRef = urlShare ? 'share' : null;
  const firstSession = crypto.randomUUID();
  const dev = crypto.randomUUID();
  const ps = prior();
  s(K.i, JSON.stringify({ prior_state: ps, first_ref: firstRef, first_session: firstSession }));
  s(K.d, dev);
  if (!j(K.i)) return true;
  writeS(firstSession, Date.now());
  send({ device_id: dev, session_id: firstSession, name: 'app_open', ref: urlShare ? 'share' : null, prior_state: ps, fs: 1, first_ref: firstRef });
  return true;
};

export function initTelemetry() {
  try {
    if (blocked()) return;
    const urlShare = new URLSearchParams(location.search).get('ref') === 'share';
    if (urlShare) stripRef();
    const created = ensureInit(urlShare);
    if (!created) (urlShare ? open('share') : sync());
    document.addEventListener('visibilitychange', () => { try { if (document.visibilityState === 'visible') sync(); } catch { /* ignore */ } });
  } catch { /* ignore */ }
}

export function touchSessionOnSwap() {
  try {
    if (blocked()) return;
    const sess = j(K.s); if (!sess) return;
    if (Date.now() - sess.lastTs > GAP) { open(null); return; }
    writeS(sess.id, Date.now());
  } catch { /* ignore */ }
}

export function track(name, fields) {
  try {
    if (blocked()) return;
    sync();
    const sessionId = sid(); const dev = g(K.d);
    if (!sessionId || !dev) return;
    writeS(sessionId, Date.now());
    send({ device_id: dev, session_id: sessionId, name, ...fields, ...cohort(sessionId) });
  } catch { /* ignore */ }
}
